import { isEmpty } from "./strings.pipe";

export function snipAthleteId(athleteId: string, len: number = 8): string {
	if( isEmpty(athleteId) ) return '';
	if( athleteId.includes('not') ) return athleteId;
	return athleteId.substring(0, len) + '...';
}

